import { useStore } from "@/store";
import { RouterName } from "@/enums/RouterEnum";
import { useRouter } from "@/router";
const getRedirectPath = () => {
  // return process.env.IS_ELECTRON ? "/clientCallback" : "/callback";
  if (process.env.IS_ELECTRON) {
    if (process.env.VUE_APP_ENV === "production") {
      return "https://dianshudata.com/clientCallback";
    }
    return "https://test.dianshudata.com/clientCallback";
  }
};

// 基础配置
export const baseConfig = {
  development: {
    serverUrl: "https://test-sso.dianshudata.com",
    clientId: "2ca9e76c06266f8be002",
    organizationName: "dianshu",
    appName: "dianshu",
    clientSecret: "98216b37ea716590113eb7e4900dc4672986089d",
  },
  production: {
    serverUrl: "https://sso.dianshudata.com",
    clientId: "fcdfeb6531b13151851f",
    organizationName: "dianshu",
    appName: "dianshu",
    clientSecret: "3dd77f9c2095891c955520586116d7ffd4d52d78", // 待替换
  },
};

// 合并配置
export const casdoorConfig = {
  ...baseConfig[
    process.env.VUE_APP_ENV === "production" ? "production" : "development"
  ],
  redirectPath: getRedirectPath(),
};

// 刷新token
export const refreshCasdoorToken = async (retryCount = 3) => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    console.error("No refresh token found");
    return null;
  }

  const IS_ELECTRON = process.env.IS_ELECTRON;
  const getRefreshTokenUrl = () => {
    if (process.env.VUE_APP_ENV === "development") {
      return `${baseConfig.development.serverUrl}/api/login/oauth/refresh_token`;
    }
    return `${baseConfig.production.serverUrl}/api/login/oauth/refresh_token`;
  };

  for (let i = 0; i < retryCount; i++) {
    try {
      let data;
      if (IS_ELECTRON) {
        // 在 Electron 环境中使用主进程发送请求
        console.log(
          "Electron: Sending refresh token request to:",
          getRefreshTokenUrl()
        );
        console.log("Electron: Request payload:", {
          refreshToken: refreshToken.substring(0, 10) + "...",
          clientId: casdoorConfig.clientId,
          clientSecret: casdoorConfig.clientSecret.substring(0, 10) + "...",
        });

        data = await window.electronAPI.refreshToken({
          url: getRefreshTokenUrl(),
          refreshToken,
          clientId: casdoorConfig.clientId,
          clientSecret: casdoorConfig.clientSecret,
        });

        console.log("Electron: Received response:", data);
      } else {
        // 在 Web 环境中使用 fetch
        console.log(
          "Web: Sending refresh token request to:",
          getRefreshTokenUrl()
        );
        const response = await fetch(getRefreshTokenUrl(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            grant_type: "refresh_token",
            refresh_token: refreshToken,
            scope: "openid",
            client_id: casdoorConfig.clientId,
            client_secret: casdoorConfig.clientSecret,
          }),
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Web: HTTP error response:", {
            status: response.status,
            statusText: response.statusText,
            body: errorText,
          });
          throw new Error(
            `HTTP error! status: ${response.status}, body: ${errorText}`
          );
        }

        data = await response.json();
        console.log("Web: Received response:", data);
      }

      if (!data) {
        console.error("Received null or undefined response");
        throw new Error("Null response received");
      }

      if (!data.access_token || !data.refresh_token) {
        console.error("Invalid token response:", data);
        throw new Error(
          "Invalid token response: missing access_token or refresh_token"
        );
      }

      localStorage.setItem("token", data.access_token);
      localStorage.setItem("refreshToken", data.refresh_token);
      localStorage.setItem("isLogin", "1");
      console.log("Token refresh successful");
      const tokens = await window.electronAPI.getToken();
      if (tokens) {
        tokens.token = data.access_token;
        tokens.refreshToken = data.refresh_token;
        tokens.isLogin = "1";
        await window.electronAPI.saveToken(tokens);
      }
      return data;
    } catch (error) {
      console.error(`Token refresh attempt ${i + 1} failed:`, error);
      if (i === retryCount - 1) {
        // 最后一次重试也失败了
        console.error("All token refresh attempts failed");
        return null;
      }
      // 等待一秒后重试
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const store = useStore() as any;
      const router = useRouter();
      store.dispatch("user/logout");
      router.push(RouterName.LOGIN);
      return null;
    }
  }

  return null;
};
